import { createSelector } from '@reduxjs/toolkit';
import { FDealType, FOfferType } from '../../../../packages/JsonQuery';
import { selectDealType, selectIsSubsidizedMortgage, selectOfferType } from 'shared/selectors/jsonQuery';

export const selectSubsidizedMortgageValue = createSelector(
  [selectDealType, selectOfferType, selectIsSubsidizedMortgage],
  (dealType, offerType, isSubsidizedMortgage) => {
    const isSale = dealType === FDealType.Sale;
    const isFlatOld = (offerType & FOfferType.FlatOld) !== 0;

    if (!isSale || !isFlatOld) {
      return null;
    }

    return isSubsidizedMortgage;
  },
);
